import { useEffect, useState } from "react";
import { Col, Modal } from "react-bootstrap";
import { api } from "../../constants/Services";

function WorkOrderTableAmd({
  type,
  workOrderDetail,
  orderType,
  poppupHandle,
  tabelBoq,
  tabelData,
  setTableData,
  setViewTable,
  companyData,
  vendorData,
}) {
  const Table_heading = [
    "S.No",
    "BOQ Code",
    // "Boq Description",
    "Work Description",
    "UOM",
    // orderType,
    "Quantity",
    "Basic Rate",
    "Total Value",
    "Misc",
    "Net Value",
    "Remarks",
  ];

  const [micsPoppup, setMicePoppup] = useState(false);
  const [row, setRow] = useState([1]);
  const [boq, setBoq] = useState({});

  useEffect(() => {
    setBoq({});
  }, [tabelBoq]);

  useEffect(() => {
    if (type == "work-order-amendment") {
    }
  }, [type]);

  const addRow = () => {
    let temp = [...row];
    temp.push(1);
    setRow(temp);
  };

  const [selId, setSelId] = useState(null);
  const [selInd, setSelInd] = useState(null);
  const miscModalHandler = (id, price, ind) => {
    console.log(price, id, ind);
    setCommonFields({
      ...commonFields,
      total_price: { ...commonFields?.total_price, [+id]: +price },
    });
    setMicePoppup(true);
    setSelId(id);
    setSelInd(ind);
  };

  const [hsnDetail, setHsnDetail] = useState({
    hsn_code: "",
    hsn_des: "",
    igst: "",
    sgst: "",
    cgst: "",
    igst_value: "",
    sgst_value: "",
    cgst_value: "",
  });

  const [miscDetails, setMiscDetails] = useState({
    discount_value: "",
    dis_percent: "",
    total_val_af_dis: "",
    net_value: "",
  });

  const [commonFields, setCommonFields] = useState({
    basic_price: {},
    total_price: {},
    remarks: {},
  });

  const calcu_percentage_value = (percent, total_value) => {
    const percentate_value = (percent / 100) * total_value;
    return percentate_value;
  };

  const roundOffActionHandler = (action) => {
    let temp;
    if (action == "-") temp = Math.floor(miscDetails?.net_value);
    else temp = Math.ceil(miscDetails?.net_value);
    setMiscDetails({ ...miscDetails, net_value: temp });
  };

  const revisedTotalCalc = (tot_val, dis_val) => tot_val - dis_val;

  const miscDiscountHandler = async (percent, total_price) => {
    const disVal = calcu_percentage_value(+percent, +total_price);
    const revised_total = revisedTotalCalc(+total_price, +disVal);
    let net_value;

    if (disVal && revised_total) {
      const cgst = calcu_percentage_value(hsnDetail.cgst[selId], revised_total);
      const sgst = calcu_percentage_value(hsnDetail.sgst[selId], revised_total);
      setHsnDetail({
        ...hsnDetail,
        sgst_value: { [selId]: cgst },
        cgst_value: { [selId]: sgst },
      });
      net_value = cgst + sgst;
    }
    setMiscDetails({
      discount_value: disVal,
      dis_percent: percent,
      total_val_af_dis: revised_total,
      net_value: net_value,
    });
  };

  const searchHsn = (hsn_code, total_val) => {
    let data = {
      code: hsn_code,
    };
    api.searchHSN(data).then((res) => {
      if (res?.status === "success") {
        if (companyData?.state !== vendorData?.state) {
          console.log("state!");
          setHsnDetail({
            hsn_code: {
              ...hsnDetail?.hsn_code,
              // [selId]: res?.hsn_code?.code_name,
              [selId]: res?.hsn_code?.id,
            },
            hsn_des: {
              ...hsnDetail?.hsn_des,
              [selId]: res?.hsn_code?.description,
            },
            igst: { ...hsnDetail?.igst, [selId]: res?.hsn_code?.igst },
            igst_value: {
              ...hsnDetail?.igst_value,
              [selId]: calcu_percentage_value(res?.hsn_code?.igst, total_val),
            },
            sgst: { ...hsnDetail?.sgst, [selId]: "-" },
            cgst: { ...hsnDetail?.cgst, [selId]: "-" },
            sgst_value: { ...hsnDetail?.sgst_value, [selId]: "-" },
            cgst_value: { ...hsnDetail?.cgst_value, [selId]: "-" },
          });
          setMiscDetails({
            ...miscDetails,
            net_value: calcu_percentage_value(res?.hsn_code?.igst, total_val),
          });
        } else {
          setHsnDetail({
            ...hsnDetail,
            hsn_code: {
              ...hsnDetail?.hsn_code,
              [selId]: res?.hsn_code?.code_name,
            },
            hsn_des: {
              ...hsnDetail?.hsn_des,
              [selId]: res?.hsn_code?.description,
            },
            igst: { ...hsnDetail?.igst, [selId]: "-" },
            igst_value: { ...hsnDetail?.igst_value, [selId]: "-" },
            sgst: { ...hsnDetail?.sgst, [selId]: res?.hsn_code?.sgst },
            sgst_value: {
              ...hsnDetail?.sgst_value,
              [selId]: calcu_percentage_value(res?.hsn_code?.sgst, total_val),
            },
            cgst: { ...hsnDetail?.cgst, [selId]: res?.hsn_code?.cgst },
            cgst_value: {
              ...hsnDetail?.cgst_value,
              [selId]: calcu_percentage_value(res?.hsn_code?.cgst, total_val),
            },
          });

          setMiscDetails({
            ...miscDetails,
            net_value:
              calcu_percentage_value(res?.hsn_code?.sgst, total_val) +
              calcu_percentage_value(res?.hsn_code?.cgst, total_val),
          });
        }
      }
    });
  };

  const miscSubmitHandler = () => {
    let temp = [...tabelData];
    let obj = temp[selInd];

    let final = {
      ...obj,
      misc_value: Number(miscDetails?.net_value).toFixed(2),
      net_value: +miscDetails?.net_value + +obj?.total_value,
    };

    temp[selInd] = final;

    setTableData(temp);
    setMicePoppup(false);
  };

  const getMaterial = (item) => {
    let split = item?.split(",");
    console.log(split);
    let finder = tabelBoq?.find((i) => i?.id == +split[0]);
    console.log("finder", finder);
    setBoq((val) => ({ ...val, [+split[1]]: finder }));
  };

  const handleChange = (event, ind, type) => {
    // let obj = { ...boq[ind] };
    let temp = [...tabelData];
    let obj = temp[ind];

    if (type == "qty" || type == "basic_price") {
      let final = {
        ...obj,
        [type]: event,
        ["total_value"]:
          type == "qty"
            ? +obj?.basic_price * +event
            : type == "basic_price"
            ? +obj?.qty * +event
            : 0,
        ["misc"]: "",
        ["net_value"]: "",
      };
      temp[ind] = final;
      setTableData(temp);
    } else {
      let final = {
        ...obj,
        [type]: event,
      };

      temp[ind] = final;

      setTableData(temp);
    }
  };

  // console.log("boq", boq);

  const checkBox = (item) => {
    let temp = [...tabelData];

    let inx = temp.indexOf(item);

    if (temp.includes(item)) {
      temp.splice(inx, 1);
    } else {
      temp.push(item);
    }

    setTableData(temp);
  };

  console.log("tabelData", companyData, vendorData);

  return (
    <Col
      style={{ width: "95%" }}
      className="emply-master-form px-3 py-2 py-md-4 bg-white mt-3 text-center me-auto"
    >
      {/* <Col xs={12} className="d-flex mb-2">
        <button
          className="bg-primar border-0 rounded-1 my-1 text-white f-1 fs-14 px-4 py-2 ms-auto"
          onClick={() => addRow()}
        >
          Add
        </button>
      </Col> */}
      <Col className="emply-master-form py-2  mt-3 text-center">
        <div style={{ overflowX: "scroll" }} className="boq-table bg-white ">
          <table className="table">
            <thead>
              <tr>
                {Table_heading?.map((heading) => (
                  <th>{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody className="text-center">
              {tabelData?.map((item, ind) => {
                return (
                  <tr>
                    <td> {ind + 1}</td>
                    <td>{item?.boq_detail?.boq_code}</td>
                    <td>
                      <input
                        onChange={(e) =>
                          handleChange(e.target.value, ind, "description")
                        }
                        value={item?.description}
                        className="border-0"
                      />
                    </td>
                    <td> {item?.boq_detail?.uom}</td>
                    <td>
                      {" "}
                      <input
                        onChange={(e) =>
                          handleChange(e.target.value, ind, "qty")
                        }
                        value={item?.qty}
                        className="border-0"
                        type={"number"}
                      />
                    </td>
                    <td>
                      <input
                        onChange={(e) =>
                          handleChange(e.target.value, ind, "basic_price")
                        }
                        value={item?.basic_price}
                        className="border-0"
                        type={"number"}
                      />
                    </td>
                    <td>{item?.total_value}</td>
                    <td className="">
                      {item?.misc_value ? (
                        item?.misc_value
                      ) : item?.misc ? (
                        item?.misc
                      ) : (
                        <button
                          className="border-0 bg-primary1 rounded-1 text-white"
                          onClick={() =>
                            miscModalHandler(item?.id, item?.total_value, ind)
                          }
                          disabled={item?.total_value ? false : true}
                        >
                          Misc
                        </button>
                      )}
                    </td>
                    <td> {item?.net_value}</td>
                    <td className="text-center">
                      {" "}
                      <input
                        onChange={(e) =>
                          handleChange(e.target.value, ind, "remarks")
                        }
                        value={item?.remarks}
                        className="border-0"
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Col>

      {/* Misc Poppup start */}
      {micsPoppup && (
        <Modal
          show={micsPoppup}
          centered
          onHide={() => {
            setMicePoppup(!micsPoppup);
          }}
        >
          <>
            <Modal.Header closeButton className="border-0">
              <h5 className="mx-auto">Miscellaneous Screen</h5>
            </Modal.Header>
            <Modal.Body>
              <div className="w-100 my-1 py-1">
                <label style={{ width: "140px" }} className="fs-14 me-2">
                  HSN Code
                </label>
                <input
                  onChange={(e) =>
                    searchHsn(e.target.value, commonFields?.total_price[selId])
                  }
                />
              </div>
              <div className="w-100 my-1 py-1">
                <label style={{ width: "140px" }} className="fs-14 me-2">
                  HSN Description
                </label>
                <input value={hsnDetail?.hsn_des[selId] ?? " "} />
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    Total Value
                  </label>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={commonFields?.total_price[selId]}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    Total Value After Discount
                  </label>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={miscDetails?.total_val_af_dis}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    Discount
                  </label>
                  <input
                    className="w-25"
                    onChange={(e) =>
                      miscDiscountHandler(
                        e.target.value,
                        commonFields?.total_price[selId]
                      )
                    }
                  />
                  <span className="ms-1">%</span>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={miscDetails?.discount_value}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    IGST
                  </label>
                  <input
                    className="w-25"
                    readOnly
                    value={hsnDetail?.igst[selId]}
                  />
                  <span className="ms-1">%</span>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={hsnDetail?.igst_value[selId] ?? ""}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    SGST
                  </label>
                  <input
                    className="w-25"
                    readOnly
                    value={hsnDetail?.sgst[selId]}
                  />
                  <span className="ms-1">%</span>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={hsnDetail?.sgst_value[selId]}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    CGST
                  </label>
                  <input
                    className="w-25"
                    readOnly
                    value={hsnDetail?.cgst[selId]}
                  />
                  <span className="ms-1">%</span>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    value={hsnDetail?.cgst_value[selId]}
                  />
                </Col>
              </div>
              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    Round Off
                  </label>
                  <button
                    className="border-0 me-1 bg-primary1"
                    onClick={() => roundOffActionHandler("+")}
                  >
                    +
                  </button>
                  <button
                    className="border-0 ms-1 bg-primary2"
                    onClick={() => roundOffActionHandler("-")}
                  >
                    -
                  </button>
                </Col>
              </div>

              <div className="w-100 d-flex my-1 py-1">
                <Col xs={8}>
                  <label style={{ width: "140px" }} className="fs-14 me-2">
                    Net Value
                  </label>
                </Col>
                <Col xs={4}>
                  <label className="fs-14 me-2">Value</label>
                  <input
                    className="w-50"
                    readOnly
                    type="text"
                    value={
                      miscDetails?.net_value
                        ? Number(miscDetails?.net_value).toFixed(2)
                        : ""
                    }
                  />
                </Col>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
              <button
                onClick={() => setMicePoppup(false)}
                className="bg-gray border-0 rounded-1 my-3 lightBlue f-1 fs-14 px-4 py-2 ms-3"
              >
                Cancel
              </button>
              <button
                className="bg-primar border-0 rounded-1 my-3 text-white f-1 fs-14 px-4 py-2"
                onClick={miscSubmitHandler}
              >
                Save
              </button>
            </Modal.Footer>
          </>
        </Modal>
      )}
      {/* Misc Poppup end */}
    </Col>
  );
}

export default WorkOrderTableAmd;
